import Vue from 'vue'
import path from 'path'
import App from './App.vue'
import router from './router'
import global from './common/global.js'
import Vant from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import 'vant/lib/index.css';
import utils from './common/util.js' 
import htmlToPdf from './mixins/htmlToPdf'
import VueQuillEditor from 'vue-quill-editor'
import plugins from './components/plugins.js'

import { Search } from 'vant';
import { Cell, CellGroup } from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(plugins);
Vue.use(htmlToPdf)
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

// Vue.use(VueQuillEditor)
Vue.use(htmlToPdf)
Vue.use(Vant);
Vue.use(Dialog);
import { Lazyload } from 'vant';
Vue.use(Lazyload, { lazyComponent: true });

import './utils/remConfig'

import './assets/style/reset.css'
import './assets/style/srsun.css'
import axios from './utils/axios.js'
import localcache from './utils/localcache.js'
import axios_request from './common/axios_request.js'
import getregister from './common/getregister.js'

// import VConsole from 'vconsole';
// let vconsole = new VConsole();


// // 判定pc端不能打开
   //对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器S
  //  var useragent = navigator.userAgent;
  //  if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
  //      var opened = window.open('about:blank', '_self');
  //      opened.opener = null;
  //      opened.close();
  //  }

 
// loading
Vue.prototype.$showLoad = (message) => Toast.loading({ duration: 0, forbidClick: true, message: message ? message : '加载中...' })
Vue.prototype.$hideLoad = () => Toast.clear(true)
Vue.prototype.$showDialog_confirm  = (message,iscel,beforeClose) => Dialog.confirm({message:message,confirmButtonColor:"#5B8DF6",beforeClose,showCancelButton:iscel}).then(() => {})
Vue.prototype.$utils = utils
Vue.prototype.$global = global
Vue.prototype.$bus = new Vue()
Toast.setDefaultOptions({ duration: 2000 })
Toast.setDefaultOptions('loading', { forbidClick: true })

Vue.prototype.$toFixed = (num, decimal) => {
  if (num == 0 || num == "" || !num) {
    return "0.00"
  }
  decimal = decimal ? decimal : 2
  num = num + '';
  var index = num.indexOf('.');
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1)
  } else {
    num = num.substring(0)
  }
  return parseFloat(num).toFixed(decimal)
}
Vue.prototype.$axios_request = axios_request
Vue.prototype.$axios = axios
Vue.prototype.$local = localcache
Vue.prototype.$getregister=getregister
Vue.config.productionTip = false

// wx.config({
//   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//   appId: '', // 必填，公众号的唯一标识
//   timestamp: "", // 必填，生成签名的时间戳
//   nonceStr: '', // 必填，生成签名的随机串
//   signature: '',// 必填，签名，见附录1
//   // 必填，需要使用的JS接口列表，所有JS接口列表见官方js接口
//   // 这里配置获取地理位置所需要的接口权限
//   jsApiList: [
//     'openLocation',
//     'getLocation'
//   ]
// });
// wx.ready(function(){
//   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
// });
// wx.error(function(res){
//   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
// });
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
